// useDailyImproveNews — drives the daily-improve "What's New" pop-up (F4). Checks the last run
// report on mount and whenever the window regains focus (the cron runs while the app is closed/
// backgrounded), and opens the modal once per run that produced news. Dismiss marks it seen.
import { useCallback, useEffect, useState } from 'react';
import { getLastReport, shouldShow, markSeen } from '../lib/dailyImproveStore.js';

export function useDailyImproveNews() {
  const [report, setReport] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let alive = true;
    const check = async () => {
      const r = await getLastReport();
      if (!alive || !r || !shouldShow(r)) return;
      setReport(r);
      setOpen(true);
    };
    check();
    window.addEventListener('focus', check);
    return () => { alive = false; window.removeEventListener('focus', check); };
  }, []);

  const dismiss = useCallback(() => {
    if (report) markSeen(report);
    setOpen(false);
  }, [report]);

  return { report, open, dismiss };
}
